import { Long, Timestamp } from 'streem-sdk-protobuf';
export const getProtobufTimestamp = () => {
    const millis = new Date().getTime();
    return new Timestamp({
        seconds: new Long(millis / 1000),
        nanos: (millis % 1000) * 1e6,
    });
};
//# sourceMappingURL=get_protobuf_timestamp.js.map